import { Document } from '../interfaces/Document';
import Configuration from './Configuration';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function buildDocument(level: string, details: any, id: string, correlationId: string): Document {
  const config = Configuration.Current();
  return {
    application: config.applicationName,
    correlationId,
    details: {
      ...details,
      userAgent: window.navigator.userAgent,
    },
    environment: config.environment,
    id,
    infra: 'react',
    levelStr: level,
    monitoringScope: config.monitoringScope,
    silo: Number(config.silo),
  };
}
